<template>
  <div class="kontrollerDealerOneComp">
    <tbl-one-comp :rows="dealerTbl"/>
  </div>
</template>

<script>
export default {
  name: 'kontrollerDealerOneComp',
  props: {
    params: {
      type: Object,
      default: function () { return {} }
    }
  },
  data: function () {
    return {
      moduleName: 'kontrollers',
      required: [
        'DEALER_ID',
        'DEALER_NAME',
        'DEALER_MOBTEL',
        'DEALER_REGION',
        'DEALER_OBLAST',
        'DEALER_CITY',
        'DEALER_STREET',
        'DEALER_DOM',
        'DEALER_INN',
        'DEALER_KPP',
        'DEALER_OGRN',
        'DEALER_OKPO',
        'DEALER_FIORUK',
        'DEALER_FIOBUH',
        'DEALER_FIOMGR',
        'DEALER_EMAIL'
      ]
    }
  },
  created: function () {
    // this.$store.dispatch(`${this.moduleName}/getOne`, {params: this.params, required: this.required});
  },
  components: {
  },
  computed: {
    dealerTbl: function () {
      let model = this.$store.getters[`${this.moduleName}/getOne`]
      return this.$helpers.mapper.modelRequired(this.required, model)
    }
  },
  methods: {
  }
}
</script>

<style scoped lang="scss">
</style>
